import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { Button } from '@superdispatch/ui-lab';

interface Props {
  message: string | undefined;
}

export function LoadboardMobileErrorDialog({ message }: Props) {
  return (
    <Dialog open={true} fullWidth={true}>
      <DialogTitle>
        <Typography variant="h3">Error</Typography>
      </DialogTitle>

      <DialogContent>{message}</DialogContent>

      <DialogActions>
        <Button
          variant="neutral"
          fullWidth={true}
          onClick={() => {
            window.location.reload();
          }}
        >
          Retry
        </Button>
      </DialogActions>
    </Dialog>
  );
}
